import { Avatar, makeStyles } from "@material-ui/core";
import React, { useState } from "react";
import celular from "../../../../assets/images/home/celular-embaixo.png";
import SectionMain from "../../../../components/SectionMain";

const useStyles = makeStyles({
  containerThree: {
    background: "linear-gradient(-180deg, #6eb64b 0.00%, #009daa 100.00%)",
    // clipPath: "ellipse(100% 50%)",
    borderRadius: "0% 0% 150% 150%/0% 0% 40% 40%",
    paddingBottom: "15%",
  },
  leftSectionThree: {
    height: "100%",
    maxWidth: "80%",
    margin: "auto",
    marginTop: 50,
  },
  viewCenter: { width: "88%", margin: "auto", marginBottom: 50 },
  titleSectionThree: {
    fontFamily: "Century Gothic",
    fontSize: "25px",
    fontWeight: "normal",
    fontStyle: "normal",
    textAlign: "center",
    color: "#ffffff",
  },
  descriptionThree: {
    fontFamily: "Century Gothic",
    fontSize: "14px",
    fontWeight: "normal",
    fontStyle: "normal",
    textAlign: "center",
    color: "#ffffff",
  },
  divOne: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    marginTop: 15,
  },
  divTwo: {},
  divThree: {
    fontFamily: "Century Gothic",
    fontSize: "23px",
    fontWeight: "normal",
    fontStyle: "normal",
    textAlign: "left",
    alignSelf: "flex-end",
    color: "#fafafb",
    marginBottom: "20px",
    display: "flex",
    alignItems: "baseline",
  },
  divFour: {
    height: "20px",
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-end",
  },
  divFive: {
    width: "8px",
    height: "8px",
    borderRadius: "4px",
    backgroundColor: "#faad13",
    marginBottom: 10,
    marginRight: 10,
  },
  size: {
    fontSize: "16px",
  },
});

const data = [
  {
    title: "Meditações",
    description:
      "Meditações guiadas por professores para acalmar a mente e desenvolver mais foco, equilíbrio e gratidão.",
  },
  {
    title: "MiniMedita",
    description:
      "Meditações, exercícios de yoga para crianças e músicas que ajudam a relaxar e dormir bem.",
  },
  {
    title: "Yoga",
    description:
      "Práticas leves e fáceis de fazer, conduzidas por professores de diversas linhas de Yoga.",
  },
  {
    title: "Mantras",
    description:
      "Afirmações poderosas, mantras e orações para o dia a dia, unindo mente e espírito.",
  },
  {
    title: "Músicas",
    description:
      "Relaxe ou energize-se com sons da natureza e músicas que equilibram seu corpo e mente.",
  },
  {
    title: "Exercícios",
    description:
      "Respiração, alongamento, pilates e muito mais para tonificar o corpo e melhorar sua saúde.",
  },
];

const SectionThree = () => {
  const classes = useStyles();

  return (
    <SectionMain noPadding className={classes.containerThree}>
      <SectionMain noPadding item className={classes.leftSectionThree}>
        <div className={classes.viewCenter}>
          <div className={classes.titleSectionThree}>
            Encontre alívio e bem-estar com o MeditaBem
            <br />
            <span className={classes.descriptionThree}>
              Estresse e mente sobrecarregada? Conheça as modalidades voltadas
              para o seu bem-estar e escolha as práticas que mais combinam com
              você e o seu estilo de vida.
            </span>
          </div>
        </div>
        <div className={classes.divOne}>
          <div className={classes.divTwo}>
            {data.map((d) => (
              <div className={classes.divThree}>
                <div className={classes.divFour}>
                  <div className={classes.divFive} />
                </div>
                <div>
                  {d.title}
                  <br />
                  <span className={classes.size}>{d.description}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </SectionMain>
    </SectionMain>
  );
};

export default SectionThree;
